<template>
  <div class="custom-margin">
    <v-row dense class="ma-2" align="center">
      <div>
        <v-btn color="#141E46" class="white--text" @click="getCurrentDate"> 本月 </v-btn>
      </div>
      <div class="mx-2">
        <v-row dense>
          <v-col>
            <v-btn tile color="#BB2525" class="white--text" @click="prevMonth" elevation="0">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col class="mx-n4">
            <v-btn tile color="#BB2525" class="white--text" elevation="0">
              {{ formattedDate }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn tile color="#BB2525" class="white--text" @click="nextMonth" elevation="0">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-row>
    <v-row dense class="ma-2" align="center">
      <v-col cols="3">
        <v-combobox
          dense
          outlined
          label="選擇機構"
          variant="solo-filled"
          :items="institutionList"
          v-model="selectedInstitution"
          hide-details="true"
        />
      </v-col>
      <v-col cols="5">
        <v-combobox
          dense
          clearable
          chips
          multiple
          outlined
          label="選擇個案"
          variant="solo-filled"
          :items="idNumberChoiceList"
          item-text="name"
          item-value="id_number"
          v-model="selectedCases"
          hide-details="true"
        />
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" @click="filterCases"> 篩選個案 </v-btn>
      </v-col>
      <v-col cols="2" class="px-2">
        <v-btn tile color="#813d67" class="white--text" elevation="0" @click="exportReport">
          匯出核銷報表
        </v-btn>
      </v-col>
    </v-row>
    <div class="ma-2 table-row">
      <v-data-table
        :headers="headers"
        :items="records"
        :items-per-page="-1"
        class="pa-2 table"
        disable-sort
        hide-default-footer
        dense
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item, itemIndex) in items" :key="`row-${itemIndex}`">
              <td
                v-for="(header, index) in headers"
                :key="`cell-${itemIndex}-${index}`"
                class="text-add hover-add"
                @mouseover="showTooltip(item, header.value, itemIndex, $event)"
                @mouseleave="hideTooltip"
              >
                {{ item[header.value] != null ? item[header.value] : 'x' }}
                <div
                  v-if="
                    tooltipVisible &&
                    header.value === currentHeader &&
                    itemIndex === currentItemIndex
                  "
                  :style="{ left: tooltipX + 'px', top: tooltipY + 'px' }"
                  class="tooltip"
                >
                  {{ tooltipContent }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 原始未篩選資料
      originalRecords: [],
      // 顯示於表格的資料
      records: [],
      // column headers
      headers: [
        { text: '個案姓名', value: 'name' },
        { text: '服務日期', value: 'service_date' },
        { text: '服務項目代碼', value: 'service_code' },
        { text: '服務類別', value: 'service_category' },
        { text: '數量', value: 'quantity' },
        { text: '單價', value: 'unit_price' },
        { text: '服務人員', value: 'staff_name' },
        { text: '起始時段-小時(24小時制)', value: 'start_hour' },
        { text: '起始時段-分鐘', value: 'start_minute' },
        { text: '結束時段-小時(24小時制)', value: 'end_hour' },
        { text: '結束時段-分鐘', value: 'end_minute' },
        { text: '備註', value: 'remarks' },
        { text: 'BD03、DA01使用-出發地', value: 'departure_location' },
        { text: 'BD03、DA01使用-目的地', value: 'destination' },
        { text: 'BD03、DA01使用-出發地(經度)', value: 'departure_longitude' },
        { text: 'BD03、DA01使用-出發地(緯度)', value: 'departure_latitude' },
        { text: 'BD03、DA01使用-目的地(經度)', value: 'destination_longitude' },
        { text: 'BD03、DA01使用-目的地(緯度)', value: 'destination_latitude' },
        { text: 'BD03、DA01使用-里程數(公里)', value: 'mileage' },
        { text: 'BD03、DA01使用-車號', value: 'vehicle_number' },
        { text: 'BD03必填-服務使用類型', value: 'service_use_type' },
      ],
      // 機構清單、個案清單
      institutionList: [],
      idNumberChoiceList: [],
      // 選擇器模型
      selectedDate: new Date(),
      selectedInstitution: '全部',
      selectedCases: [],
      selectedNumbers: [],
      // tooltip 相關
      tooltipVisible: false,
      tooltipContent: '',
      tooltipX: 0,
      tooltipY: 0,
      currentHeader: '',
      currentItemIndex: null,
    }
  },
  computed: {
    formattedDate: {
      get() {
        const year = this.selectedDate.getFullYear()
        const month = this.selectedDate.getMonth() + 1
        return `${year}-${month.toString().padStart(2, '0')}`
      },
      set(newValue) {
        const [year, month] = newValue.split('-').map(Number)
        this.selectedDate = new Date(year, month - 1)
      },
    },
  },
  watch: {
    // 當機構變更時，更新「選擇個案」清單
    selectedInstitution() {
      this.updateIdNumberChoiceList()
    },
    // 當月份變動時，重新撈清單
    selectedDate() {
      this.getList()
    },
  },
  methods: {
    // 取得 API 清單
    async getList() {
      const axios = require('axios')
      try {
        const res = await axios.get(
          `/api/attendance/get_reimbursement_list/?month=${this.formattedDate}`,
          { timeout: 180000 }
        )
        this.originalRecords = res.data.data
        this.records = [...this.originalRecords]
        this.buildInstitutionList()
        this.updateIdNumberChoiceList()
      } catch (error) {
        console.error(error)
      }
    },
    // 建立機構清單
    buildInstitutionList() {
      const instSet = new Set()
      this.originalRecords.forEach((r) => {
        ;(r.institution || []).forEach((inst) => instSet.add(inst))
      })
      this.institutionList = ['全部', ...Array.from(instSet)]
      this.selectedInstitution = '全部'
    },
    // 根據 selectedInstitution 生成個案清單
    updateIdNumberChoiceList() {
      let filtered = this.originalRecords
      if (this.selectedInstitution !== '全部') {
        filtered = filtered.filter((r) => (r.institution || []).includes(this.selectedInstitution))
      }
      this.idNumberChoiceList = filtered.map((r) => ({
        name: r.name,
        id_number: r.id_number,
      }))
      // 清空已選個案
      this.selectedCases = []
      this.selectedNumbers = []
    },
    filterCases() {
      // 每次都從原始資料開始
      let filtered = [...this.originalRecords]

      // 先依機構篩選
      if (this.selectedInstitution !== '全部') {
        filtered = filtered.filter((r) => (r.institution || []).includes(this.selectedInstitution))
      }

      // 再依選中的個案 (可能是字串，也可能是物件)
      this.selectedNumbers = []
      if (this.selectedCases.length) {
        const ids = this.selectedCases.map((item) =>
          typeof item === 'object' ? item.id_number : item
        )
        filtered = filtered.filter((r) => ids.includes(r.id_number))
        this.selectedNumbers = [...new Set(ids)]
      }

      this.records = filtered
    },
    // 匯出報表
    async exportReport() {
      console.log(this.selectedNumbers)
      const month = this.selectedDate.toISOString().slice(0, 7)
      let fileUrl = `/api/attendance/generate_reimbursement_report/?month=${month}`
      if (this.selectedNumbers.length) {
        fileUrl += `&id_numbers=${this.selectedNumbers.join(',')}`
      }
      const link = document.createElement('a')
      link.href = fileUrl
      link.download = `data.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    // 月份切換
    getCurrentDate() {
      this.selectedDate = new Date()
    },
    prevMonth() {
      this.selectedDate = new Date(this.selectedDate.setMonth(this.selectedDate.getMonth() - 1))
    },
    nextMonth() {
      this.selectedDate = new Date(this.selectedDate.setMonth(this.selectedDate.getMonth() + 1))
    },
    // Tooltip 顯示/隱藏
    showTooltip(item, headerValue, indexValue, event) {
      if (headerValue === 'name') {
        this.tooltipContent = this.maskIdNumber(item['id_number'])
      } else if (headerValue === 'staff_name') {
        this.tooltipContent = item['staff_id']
      }
      this.tooltipVisible = true
      this.tooltipX = event.clientX + 10
      this.tooltipY = event.clientY + 10
      this.currentHeader = headerValue
      this.currentItemIndex = indexValue
    },
    hideTooltip() {
      this.tooltipVisible = false
      this.currentHeader = ''
    },
    maskIdNumber(id) {
      if (typeof id === 'string' && id.length > 6) {
        return id.slice(0, -6) + '******'
      }
      return id
    },
  },
  mounted() {
    this.getList()
  },
}
</script>

<style scoped>
.custom-margin {
  overflow-x: auto !important;
}
.table-row {
  width: 75vw;
}
.table {
  width: 100%;
  max-height: 100%;
}
</style>
